import * as THREE from 'three';

const TARGET_NAME = 'wego_eye_light_target';

export class ForwardEyeLight extends THREE.SpotLight {
  readonly surfacePosition = new THREE.Vector3();

  constructor(
    eye?: THREE.Object3D,
    color: THREE.ColorRepresentation = 0x000000,
    intensity = 0,
    distance = 0.35,
  ) {
    super(color, intensity, distance, THREE.MathUtils.degToRad(25), 1, 2);
    this.target.name = TARGET_NAME;
    this.target.position.set(0, 0, 0.05);
    this.add(this.target);
    if (!eye) return;

    eye.updateWorldMatrix(true, true);
    const inverse = eye.matrixWorld.clone().invert();
    const bounds = new THREE.Box3();
    eye.traverse((object) => {
      if (!(object instanceof THREE.Mesh)) return;
      object.geometry.computeBoundingBox();
      if (object.geometry.boundingBox) {
        bounds.union(object.geometry.boundingBox.clone().applyMatrix4(
          new THREE.Matrix4().multiplyMatrices(inverse, object.matrixWorld),
        ));
      }
    });
    if (bounds.isEmpty()) throw new Error(`Eye light has no visible geometry: ${eye.name}`);
    bounds.getCenter(this.surfacePosition);
    // The eye visual's local +Z is the robot's forward direction.
    this.surfacePosition.z = bounds.max.z + 0.0002;
    this.position.copy(this.surfacePosition);
    eye.add(this);
  }

  override copy(source: this, recursive = true): this {
    this.remove(this.target);
    super.copy(source, recursive);
    this.surfacePosition.copy(source.surfacePosition);
    this.target = this.children.find((child) => child.name === TARGET_NAME) ?? this.target;
    if (this.target.parent !== this) this.add(this.target);
    return this;
  }
}
